export const PREFIX = 'aaf_app_';

// Landing class names.
export const LANDING = `${PREFIX}landing`;

// Login class names
export const LOGIN = `${PREFIX}login`;

// Login Claromusica class names
export const LOGIN_CM = `${PREFIX}loginCM`;

// Register class names
export const REGISTER = `${PREFIX}register`;

// Password Reminder class names
export const PASSWORD_REMINDER = `${PREFIX}password-reminder`;

export const PTV = `${PREFIX}ptv`;

// AuthDevice class names
export const AUTHDEVICE = `${PREFIX}authdevice`;

// Password success class names
export const CE = `${PREFIX}`;

// const for detail Selector
export const DETAIl_S = `${PREFIX}detail_selector`;
// Register load register ip telmex
export const LOAD_REGISTER_IP_TELMEX = `${PREFIX}load-register-ipTelmex`;

// Register access code Qr or web
export const REGISTER_ACCESS_CODE = `${PREFIX}register-access-code`;

// Border color general in input outfocus
export const REGISTER_INPUT_STYLE_OUTFOCUS = '3px solid #4C6F94';

// Register header Brasil
export const LOGIN_HEADER_BRASIL = `${PREFIX}login-header-brasil`;

// Register header claromusica Brasil
export const LOGIN_CM_HEADER_BRASIL = `${PREFIX}loginCM-header-brasil`;






// WEBPACK FOOTER //
// ./src/authentication/utils/constants.ts